/**
 * Performance-related constants for admin components
 */

export const PERFORMANCE_CONSTANTS = {
  // FlatList optimization constants
  CONVERSATION_ITEM_HEIGHT: 80,
  MESSAGE_ITEM_HEIGHT: 60,
  
  // Pagination constants
  CONVERSATIONS_PER_PAGE: 20,
  MESSAGES_PER_PAGE: 50,
  
  // Rendering optimization
  INITIAL_NUM_TO_RENDER: 10,
  MAX_TO_RENDER_PER_BATCH: 10,
  WINDOW_SIZE: 10,
  
  // Polling intervals
  CONVERSATION_POLLING_INTERVAL: 10000, // 10 seconds
  MESSAGE_POLLING_INTERVAL: 5000, // 5 seconds
  
  // Debounce delays
  SEARCH_DEBOUNCE_DELAY: 300,
  SCROLL_DEBOUNCE_DELAY: 100,
  
  // Memory management
  MAX_CACHED_CONVERSATIONS: 100,
  MAX_CACHED_MESSAGES: 500,
} as const;

export const FLATLIST_PROPS = {
  removeClippedSubviews: true,
  maxToRenderPerBatch: PERFORMANCE_CONSTANTS.MAX_TO_RENDER_PER_BATCH,
  windowSize: PERFORMANCE_CONSTANTS.WINDOW_SIZE,
  initialNumToRender: PERFORMANCE_CONSTANTS.INITIAL_NUM_TO_RENDER,
  updateCellsBatchingPeriod: 100,
  getItemLayout: (itemHeight: number) => (data: any, index: number) => ({
    length: itemHeight,
    offset: itemHeight * index,
    index,
  }),
} as const;
